import "./MapLayerSelector.scss"
import { useState } from "react";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { IMapLayer } from "../../../../shared/models/map_models";
import { Box, Button, Checkbox, FormGroup, Popover } from "@mui/material";


interface IMapLayerSelectorProps {
    layers: Array<IMapLayer>
    activeLayer: IMapLayer,
    setActiveLayer: (layer: IMapLayer) => void,
    setLayerVisible: (layerId: number) => void
}

export const MapLayerSelector = (props: IMapLayerSelectorProps) => {

    const [expand, setExpand] = useState(false)
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleExpand = () => {
        const layerSelector = document.getElementById('layer-selector')
        setAnchorEl(layerSelector)
        setExpand(!expand)
    }

    const handleClose = () => {
        setAnchorEl(null)
        setExpand(!expand)
    }

    const handleSetActiveLayer = (layer: IMapLayer) => {
        handleClose()
        props.setActiveLayer(layer)
    }

    return (
        <>
            <List className="layer-selector">
                <ListItemButton 
                    sx={{padding: 0, textAlign: "center", height: "100%", p: 1}} 
                    id="layer-selector" 
                    onClick={handleExpand}
                >
                    <ListItemText 
                        sx={{display: "flex", flexDirection: "column-reverse"}}
                        primary={props.activeLayer.name}
                        secondary={"Map Layer"} 
                        slotProps={{
                            secondary: {
                                sx: {
                                    textAlign: "left"
                                }
                            }
                        }}
                    />
                    {expand ? <ExpandLess className="expand-icon"/> : <ExpandMore className="expand-icon"/>}
                </ListItemButton>
                <Collapse in={expand} timeout="auto" unmountOnExit>
                    <Popover
                        open={expand}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <FormGroup className="layer-selector-popup">
                            {props.layers.map((layer) => {
                                return (
                                    <Box key={layer.id} sx={{display: "flex"}}>
                                        <Checkbox
                                            checked={layer.visible}
                                            onClick={() => props.setLayerVisible(layer.id)}
                                            sx={{padding: "5px"}}
                                        />
                                        <Button
                                            className="layer-selector-button"
                                            variant={layer.id === props.activeLayer.id ? "contained" : "outlined"}
                                            sx={{flex: 1, margin: "2px", textTransform: 'none'}}
                                            onClick={() => handleSetActiveLayer(layer)}
                                        >
                                            {layer.name}
                                        </Button>
                                    </Box>
                                )
                            })}
                        </FormGroup>
                    </Popover>
                </Collapse>
            </List>
        </>
    )
}

export default MapLayerSelector